import { AfterViewInit, Component, Input, OnDestroy, OnInit, inject, input } from '@angular/core';
import { BreakpointsDetectorService } from 'src/app/core/services/breakpoints-detector.service';
import { PlatformService } from '../../../services/platform.service';
import { ThemeService } from '../../../services/theme.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { NgClass } from '@angular/common';

@UntilDestroy()
@Component({
  selector: 'app-radial-progress',
  templateUrl: './radial-progress.component.html',
  styleUrls: ['./radial-progress.component.scss'],
})
export class RadialProgressComponent implements OnInit, AfterViewInit, OnDestroy {
  private _breakPoint = inject(BreakpointsDetectorService);
  private _platform = inject(PlatformService);
  theme = inject(ThemeService);


  readonly total = input(100);
  @Input('progress') progress = 0;
  readonly strokeWidth = input(2);

  readonly slider = input<any>(undefined);
  readonly autoplay = input(true);
  readonly arrow = input<'up' | 'down' | 'left' | 'right'>(undefined);

  public radius = 18;
  public normalizedRadius = 0;
  public circleLength = 0;

  public interval: any = 0;

  public arrowTransform: string = '';

  private _init: boolean;

  ngOnInit() {
    if (this._platform.isBrowser) {
      setTimeout(() => {
        this._init = true;
        this.normalizedRadius = this.radius - this.strokeWidth() / 2;
        this.circleLength = this.calcCircleLength(this.normalizedRadius);
        this._startTimer();
        this.calculateArrowTransform();
      }, 100);
    }
  }

  calculateArrowTransform() {
    const arrow = this.arrow();
    if (arrow === 'up') {
      this.arrowTransform = 'rotate(90deg)';
    } else if (arrow === 'down') {
      this.arrowTransform = 'rotate(270deg)';
    } else if (arrow === 'left') {
      this.arrowTransform = 'rotate(180deg)';
    } else if (arrow === 'right') {
      this.arrowTransform = 'rotate(0deg)';
    } else {
      this.arrowTransform = '';
    }
  }

  ngAfterViewInit() {
    this._resetIntervalIdSliderChanged();
  }

  ngOnDestroy() {
    this._resetInterval();
  }

  calcCircleLength(radius?: number) {
    return 2 * Math.PI * radius;
  }

  calcProgress() {
    if (this._init) {
      return this.circleLength * (1 - this.progress / this.total());
    } else {
      return this.circleLength;
    }
  }

  private _startTimer() {
    if (this.autoplay()) {
      if (this._breakPoint.isMobile) {
        this._resetInterval();
      } else {
        this.setInterval();
      }
    }
  }

  public setInterval() {
    this._resetInterval();
    this.progress = 0;
    if (this.slider()) {
      this.interval = setInterval(() => {
        this.progress += 1;
        if (this.progress >= 100) {
          this.progress = 0;
          this.slider().slider.next();
          this.setInterval();
        }
      }, 50);
    }
  }

  private _resetInterval() {
    clearInterval(this.interval);
  }

  private _resetIntervalIdSliderChanged() {
    const slider = this.slider();
    if (slider) {
      slider.slideChanged$.subscribe(() => {
        if (this.autoplay()) {
          this.setInterval();
        }
      });
    }
  }

}
